import { createContext, FC, ReactNode, useContext } from "react";
import { useLiveAPI, UseLiveAPIResults } from "../hooks/use-live-api";

export type { ConnectionStatus } from "../lib/live-proxy-client";

const LiveAPIContext = createContext<UseLiveAPIResults | undefined>(undefined);

export const LiveAPIProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const liveAPI = useLiveAPI();
  return (
    <LiveAPIContext.Provider value={liveAPI}>
      {children}
    </LiveAPIContext.Provider>
  );
};

export const useLiveAPIContext = () => {
  const context = useContext(LiveAPIContext);
  if (!context) throw new Error("useLiveAPIContext must be used within a LiveAPIProvider");
  return context;
};
